/* Avatar unique du site (createur, acheteur, compte connecte).
 *
 * Deux pieges qu'il centralise :
 *
 * 1. Une photo televersee est stockee en chemin RELATIF ("/uploads/covers/…").
 *    Utilisee telle quelle, elle pointe vers le domaine du front et renvoie
 *    404 : l'image cassee laissait croire que le site n'accepte pas les
 *    photos. Elle doit etre prefixee par l'adresse du backend.
 * 2. Le repli etait rendu par ui-avatars.com. Un service tiers decidait de
 *    l'apparence des comptes, avec une couleur differente a chaque appel selon
 *    la page, et l'identite d'un createur dependait d'un appel reseau externe.
 *    Les initiales sont desormais dessinees ici : noir sur blanc, partout.
 */
import { useState } from "react";

const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").trim();

export const resolveAvatarUrl = (picture) => {
  if (!picture) return null;
  if (/^https?:/.test(picture)) return picture;
  return `${BACKEND}${picture}`;
};

export const initialsOf = (name) =>
  (name || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase() || "?";

export default function Avatar({ name, picture, size = 40, className = "" }) {
  /* Une URL peut exister et pourtant echouer (fichier efface, volume non
     monte). Sans cet etat, la balise cassee resterait affichee : on retombe
     sur les initiales, qui ne dependent de rien. */
  const [broken, setBroken] = useState(false);
  const url = resolveAvatarUrl(picture);

  const base = {
    width: size,
    height: size,
    borderRadius: "50%",
    flexShrink: 0,
    background: "#FFFFFF",
    /* 0.07 disparaissait sur fond blanc : aux grandes tailles, la photo
       flottait sans contour. */
    border: "1px solid rgba(0,0,0,0.12)",
  };

  if (url && !broken) {
    return (
      <img
        src={url}
        alt={name || ""}
        loading="lazy"
        onError={() => setBroken(true)}
        style={{ ...base, objectFit: "cover" }}
        className={className}
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      style={{
        ...base,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#0A0A0A",
        fontWeight: 700,
        fontSize: Math.max(10, Math.round(size * 0.34)),
        lineHeight: 1,
      }}
      className={className}
    >
      {initialsOf(name)}
    </span>
  );
}
